import React from 'react';
export function PokemonIcon({
  className = ''
}) {
  return <svg className={className} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" data-id="element-303">
      <circle cx="50" cy="50" r="45" fill="#ffffff" data-id="element-304" />
      <path d="M50 5 A45 45 0 0 1 95 50 H5 A45 45 0 0 1 50 5Z" fill="#ff0000" data-id="element-305" />
      <circle cx="50" cy="50" r="15" fill="white" stroke="black" strokeWidth="4" data-id="element-306" />
      <circle cx="50" cy="50" r="7" fill="white" data-id="element-307" />
    </svg>;
}